import React, { type ReactNode } from 'react';
import { Accordion } from 'react-bootstrap';

interface ISidebarCollapseWidget {
  title: ReactNode;
  visible: boolean;
  clickFunction: () => void;
  children: ReactNode;
  titleClass?: string;
}
export const SidebarCollapseWidget = ({
  title,
  visible,
  clickFunction,
  children,
  titleClass,
}: ISidebarCollapseWidget) => {
  return (
    <Accordion
      className={visible ? 'mb-5' : 'mb-3'}
      activeKey={visible ? '0' : undefined}
      onSelect={() => clickFunction()}
      flush
    >
      <Accordion.Item eventKey="0">
        <Accordion.Header
          className={`bg-primary-subtle text-primary mb-0 border border-primary-subtle ${
            titleClass ? titleClass : ''
          } ${visible ? 'border-bottom-0' : ''}`}
        >
          {title}
        </Accordion.Header>
        <Accordion.Body className="border border-1 border-primary-subtle">{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
